import { IAppState } from '../../redux';

export function selectStrategyName(state: IAppState): string {
  const {
    auction: {
      strategy: { strategyName },
    },
  } = state;

  return strategyName;
}
